module.exports = __webpack_public_path__ + "media/assets/fonts/D-DIN-Italic-864edf356ac0a74ef27b736c1aae3105.woff";